import React from "react";
import { testimonialData } from "../../static/data";
import usama from "../../assets/usama.png";
import jonathan from "../../assets/jonathan.png";
import waleed from "../../assets/waleed.png";
import hala from "../../assets/hala.png";
import mohsin from "../../assets/mohsin.png";

const TestimonialsGrid = () => {
  return (
    <section className="testimonials-grid section" id="testimonials">
      <div className="testimonials-grid__header container">
        <div className="hero__trust-top testimonials-grid__trust">
          <div className="hero__avatars">
            <img src={usama} alt="Founder 1" className="avatar" />
            <img src={jonathan} alt="Founder 2" className="avatar" />
            <img src={waleed} alt="Founder 3" className="avatar" />
            <img src={hala} alt="Founder 4" className="avatar" />
            <img src={mohsin} alt="Founder 5" className="avatar" />
            {/* <img src={james} alt="Founder 6" className="avatar" /> */}
          </div>
          <div className="hero__trust-text">
            Trusted by <span>10+</span>
            <br /> creators and founders.
          </div>
        </div>
        <h2 className="section__title">
          Explore testimonial
          <span className="section__title-dot"></span>
        </h2>
      </div>

      <div className="testimonials-grid__container container">
        {testimonialData.map((item) => (
          <div
            key={item.id}
            className={`testimonial-card testimonial-card--${item.pos} ${item.type === "blank" ? "testimonial-card--blank" : ""} ${item.size ? `testimonial-card--${item.size}` : ""} ${item.color ? `testimonial-card--${item.color}` : ""}`}
          >
            {item.type !== "blank" && (
              <>
                <div className="testimonial-card__header">
                  <div className="testimonial-card__user">
                    <div className="testimonial-card__info">
                      <h4 className="testimonial-card__name">{item.name}</h4>
                      <p className="testimonial-card__role">{item.role}</p>
                    </div>
                    <img
                      src={item.img}
                      alt={item.name}
                      className="testimonial-card__avatar"
                    />
                  </div>
                </div>
                <div className="testimonial-card__body">
                  <p className="testimonial-card__text">{item.description}</p>
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default TestimonialsGrid;
